import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { MyAccountContactContextProvider } from './context/my-account-contact-context'
import { MyAccountPersonalDataContextProvider } from './context/my-account-personal-data-context'
import { HomeProps } from './pages/Home/Home'
import {
  AddPhoneNumber,
  CheckPhone,
  CheckEmail,
  Contacts,
  EditBirthdate,
  EditEmail,
  EditMainCell,
  EditName,
  EditPhoneNumber,
  Home,
  PersonalData,
  Preferences,
  PageShell
} from './pages'

const Routes = (props: HomeProps) => {
  return (
    <BrowserRouter basename="/minha-conta">
      <Switch>
        <Route exact path="/" render={() => <Home {...props} />} />
      </Switch>

      <Switch>
        <MyAccountPersonalDataContextProvider>
          <Route exact path="/dados-pessoais" component={PersonalData} />
          <Route exact path="/editar-nome" component={EditName} />
          <Route exact path="/editar-data-nascimento" component={EditBirthdate} />
        </MyAccountPersonalDataContextProvider>
      </Switch>

      <Switch>
        <MyAccountContactContextProvider>
          <Route exact path="/adicionar-telefone" component={AddPhoneNumber} />
          <Route exact path="/editar-celular-principal" component={EditMainCell} />
          <Route exact path="/editar-email" component={EditEmail} />
          <Route exact path="/editar-telefone" component={EditPhoneNumber} />
          <Route exact path="/meus-contatos" component={Contacts} />
          <Route exact path="/preferencias" component={Preferences} />
          <Route exact path="/validar-celular" component={CheckPhone} />
          <Route exact path="/validar-email" component={CheckEmail} />
        </MyAccountContactContextProvider>
      </Switch>

      <Switch>
        <Route exact path="/dados-complementares" component={PageShell} />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
